import { render } from "./RisqueDefis.vue?vue&type=template&id=28ba7cc7"
import script from "./RisqueDefis.vue?vue&type=script&lang=js"
export * from "./RisqueDefis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__